import { TrustBand, TrustPills } from "@/components/marketplace"
import type { TrustBandSection } from "@/features/feed/contract"
import { SectionFrame } from "@/features/feed/sections/SectionFrame"
import type { FeedSectionProps } from "@/features/feed/sections/types"

export const TrustBandFeedSection = ({ section, context }: FeedSectionProps<TrustBandSection>) => {
  const { eyebrow, title, sub, items, image, pill } = section.data
  const statement = section.presentation.variant !== "pills" && title && image
  if (!statement && !items?.length) return null
  if (statement) {
    return (
      <SectionFrame section={section} context={context}>
        <TrustBand image={image.url} imageAlt={image.alt ?? ""} eyebrow={eyebrow} title={title} sub={sub} pill={pill ?? items?.[0]?.label} />
      </SectionFrame>
    )
  }
  return (
    <SectionFrame section={section} context={context} ownsHeader gut>
      <TrustPills title={title ?? section.presentation.title?.text} items={items ?? []} />
    </SectionFrame>
  )
}
